import * as actionType from '../constants/constant.action'

const defaultState = {
  referralList: null,
  searchText: null,
  searchReferralList: [],
  loading: false,
  searchReferralFound: '',
  loadingMember: false,
  memberLoadError: '',
  openReferralMember: {},
}

const defaultAction = {
  type: undefined,
}

const referralManagementReducer = (
  state = defaultState,
  action = defaultAction
) => {
  switch (action.type) {
    case actionType.GET_REFERRAL_MANAGEMENT_REQUESTED:
      return {
        ...state,
        loading: true,
      }

    case actionType.GET_REFERRAL_MANAGEMENT_SUCCESS: {

      const referralList = action.payload
        .sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
        .map(referral => ({
          ...referral,
          referralUuid: referral.referralId,
        }))
      return {
        ...state,
        referralList,
        loading: false,
      }
    }

    case actionType.GET_REFERRAL_MANAGEMENT_FAILURE:
      return {
        loading: false,
        serverError: true,
      }

    case actionType.GET_REFERRAL_MANAGEMENT_SEARCH: {
      const { payload } = action
      const searchReferralList = state.referralList.filter(
        val =>
          (val.referralUuid &&
            val.referralUuid.toLowerCase().indexOf(payload.toLowerCase()) !==
              -1) ||
          (val.referralId &&
            val.referralId.toLowerCase().indexOf(payload.toLowerCase()) !==
              -1) ||
          val.startDate.toLowerCase().indexOf(payload.toLowerCase()) !== -1 ||
          val.endDate.toLowerCase().indexOf(payload.toLowerCase()) !== -1 ||
          (val.specialty &&
            val.specialty.toLowerCase().indexOf(payload.toLowerCase()) !==
              -1) ||
          (val.memberId &&
            val.memberId.toLowerCase().indexOf(payload.toLowerCase()) !== -1) ||
          (val.memberName &&
            val.memberName.toLowerCase().indexOf(payload.toLowerCase()) !==
              -1) ||
          (val.referringProvider &&
            val.referringProvider
              .toLowerCase()
              .indexOf(payload.toLowerCase()) !== -1) ||
          (val.referredProvider &&
            val.referredProvider
              .toString()
              .toLowerCase()
              .indexOf(payload.toLowerCase()) !== -1) ||
          (val.referralReason &&
            val.referralReason.toLowerCase().indexOf(payload.toLowerCase()) !==
              -1)
      )
      if (searchReferralList.length === 0) {
        return {
          ...state,
          searchText: payload,
          searchReferralList,
          searchReferralFound: 'No referrals matched your search.',
        }
      }
      return {
        ...state,
        searchText: payload,
        searchReferralList,
        searchReferralFound: '',
      }
    }

    case actionType.EMPTY_REFERRAL_SEARCH:
      return {
        ...state,
        searchText: null,
        searchReferralList: [],
      }

    case actionType.EXTEND_REFERRAL_SUCCESS: {
      const newReferralList = [
        action.payload.newReferral,
        ...state.referralList,
      ]
      const idx = newReferralList.findIndex(
        referral =>
          referral.referralId ===
          action.payload.originalReferral.referralId
      )
      newReferralList[idx] = action.payload.originalReferral

      const idxFiltered = state.searchReferralList.findIndex(
        referral =>
          referral.referralId ===
          action.payload.originalReferral.referralId
      )
      const newFilteredList = [...state.searchReferralList]
      if (idxFiltered !== -1) {
        newFilteredList[idxFiltered] = action.payload.originalReferral
      }
      return {
        ...state,
        referralList: newReferralList,
        searchReferralList: newFilteredList,
      }
    }

    case actionType.GET_REFERRAL_MEMBER_REQUEST: {
      return {
        ...state,
        loadingMember: true,
        openReferralMember: {},
        memberLoadError: '',
      }
    }

    case actionType.GET_REFERRAL_MEMBER_SUCCESS: {
      return {
        ...state,
        loadingMember: false,
        openReferralMember: action.payload,
        memberLoadError: '',
      }
    }

    case actionType.GET_REFERRAL_MEMBER_FAILURE: {
      return {
        ...state,
        loadingMember: false,
        openReferralMember: {},
        memberLoadError: action.payload
      }
    }

    case actionType.CLEAR_REFERRAL_MANAGEMENT:
      return defaultState

    default:
      return state
  }
}

export default referralManagementReducer
